module.exports = __webpack_public_path__ + "static/img/Noise_KK.687907f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_KK.png
// module id = DhZQ
// module chunks = 1